// Selectors


import { RootState } from '../../store';

export const userMaintenanceSelector = (state: RootState) => state.userMaintenanceState
